export default __webpack_public_path__ + "static/media/juego rio 2-25.2f21305a.png";